import React from "react";
import { FiEdit2, FiEye, FiImage } from "react-icons/fi";

import { toAbsolutePublicUrl } from "../../../../services/mediaLibraryServices";

import AdminButton from "./../../_shared/ui/AdminButton";
import AdminDrawer from "./../../_shared/ui/AdminDrawer";
import AdminStatusBadge from "./../../_shared/ui/AdminStatusBadge";
import { formatDateTime } from "../utils/newsAdminUtils";

export default function NewsPreviewDrawer({
  open,
  item,
  onClose,
  onEditFromPreview,
}) {
  const imageUrl = item?.image_url ? toAbsolutePublicUrl(item.image_url) : "";

  return (
    <AdminDrawer
      open={open}
      onClose={onClose}
      title="Aperçu de l’actualité"
      subtitle="Visualisez rapidement le rendu avant modification."
      icon={FiEye}
      size="xl"
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <AdminButton variant="secondary" onClick={onClose}>
            Fermer
          </AdminButton>

          {item?.id ? (
            <AdminButton
              icon={FiEdit2}
              variant="primary"
              onClick={onEditFromPreview}
            >
              Modifier cette actualité
            </AdminButton>
          ) : null}
        </div>
      }
    >
      {!item ? (
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Actualité introuvable.
        </p>
      ) : (
        <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.title}
              className="max-h-[420px] w-full object-cover"
            />
          ) : (
            <div className="flex min-h-[240px] flex-col items-center justify-center bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500">
              <FiImage className="text-5xl" />
              <p className="mt-3 text-sm font-bold">Aucune image associée</p>
            </div>
          )}

          <div className="p-5 sm:p-7">
            <div className="flex flex-wrap items-center gap-3">
              <AdminStatusBadge active={!!item.is_active} />

              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500 dark:bg-slate-800 dark:text-slate-400">
                {formatDateTime(item.created_at)}
              </span>
            </div>

            <h1 className="mt-5 text-3xl font-bold leading-tight text-slate-950 dark:text-white">
              {item.title}
            </h1>

            <div
              className="prose prose-slate mt-6 max-w-none dark:prose-invert prose-headings:font-bold prose-a:text-sky-600"
              dangerouslySetInnerHTML={{
                __html: item.content || "<p>Aucun contenu.</p>",
              }}
            />
          </div>
        </article>
      )}
    </AdminDrawer>
  );
}